export default "__VITE_ASSET__f2fc3df9__"